var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTop),expression:"showTop"}],staticClass:"suspend"},[_c('div',{staticClass:"service",on:{"click":_vm.service}},[_c('i',{staticClass:"iconfont icon-zhuanshukefu"})]),_c('div',{staticClass:"gotop",on:{"click":_vm.toTop}},[_c('i',{staticClass:"iconfont icon-top"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }